/**
 * Order Detail action types
 */

export const ORDER_DETAIL_REQUESTED = '[ORDER_DETAIL] REQUESTED';
export const ORDER_DETAIL_SUCCEEDED = '[ORDER_DETAIL] SUCCEEDED';
export const ORDER_DETAIL_FAILED = '[ORDER_DETAIL] FAILED';
